import React from "react";
import "../../cssfiles/homepage.css";

export default function CustomActionButton({
  buttonText,
  fontSize,
  onClick,
  disabled,
}) {
  const click = () => {
    return;
  };
  return (
    <span
      onClick={disabled ? (disabled === true ? click : onClick) : onClick}
      style={{
        fontSize: fontSize ? `${fontSize}px` : "12px",
        fontWeight: 400,
        color: disabled
          ? "var(--Searchtext_muted)"
          : "var(--HighlightedText_Stroke)",
        fontFamily: "Roboto",
        textAlign: "left",
        cursor: "pointer",
      }}
    >
      {buttonText}
    </span>
  );
}
